module.exports = __webpack_public_path__ + "base-d91855fbfcf3331557c5741ed49e6bbe.svg";